import i18next from 'i18next'
import {initReactI18next} from 'react-i18next'
import locale from './locale'
import {getSavedLanguage} from 'utils/helpers/localStorage'

void i18next.use(initReactI18next).init({
 lng: getSavedLanguage(),
 fallbackLng: 'en',
 debug: true,
 resources: {
  en: locale.en,
  hi: locale.hi,
  kn: locale.kn,
  mr: locale.mr,
  te: locale.te,
 },
})
